/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV3ServiceListPrivDoctypesGet } from '../fn/priv/api-v-3-service-list-priv-doctypes-get';
import { ApiV3ServiceListPrivDoctypesGet$Params } from '../fn/priv/api-v-3-service-list-priv-doctypes-get';
import { apiV3ServiceListPrivDoctypesGet$Plain } from '../fn/priv/api-v-3-service-list-priv-doctypes-get-plain';
import { ApiV3ServiceListPrivDoctypesGet$Plain$Params } from '../fn/priv/api-v-3-service-list-priv-doctypes-get-plain';
import { apiV3ServiceSetClientPrivPost } from '../fn/priv/api-v-3-service-set-client-priv-post';
import { ApiV3ServiceSetClientPrivPost$Params } from '../fn/priv/api-v-3-service-set-client-priv-post';
import { apiV3ServiceSetIdPrivPost } from '../fn/priv/api-v-3-service-set-id-priv-post';
import { ApiV3ServiceSetIdPrivPost$Params } from '../fn/priv/api-v-3-service-set-id-priv-post';
import { PrivDoctypesApiFrom } from '../models/priv-doctypes-api-from';

@Injectable({ providedIn: 'root' })
export class ApiFromPrivService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV3ServiceListPrivDoctypesGet()` */
  static readonly ApiV3ServiceListPrivDoctypesGetPath = '/api/v3/service/ListPrivDoctypes';

  /**
   * list of documents to confirm benefits.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceListPrivDoctypesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListPrivDoctypesGet$Plain$Response(params?: ApiV3ServiceListPrivDoctypesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PrivDoctypesApiFrom>>> {
    return apiV3ServiceListPrivDoctypesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * list of documents to confirm benefits.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceListPrivDoctypesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListPrivDoctypesGet$Plain(params?: ApiV3ServiceListPrivDoctypesGet$Plain$Params, context?: HttpContext): Observable<Array<PrivDoctypesApiFrom>> {
    return this.apiV3ServiceListPrivDoctypesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PrivDoctypesApiFrom>>): Array<PrivDoctypesApiFrom> => r.body)
    );
  }

  /**
   * list of documents to confirm benefits.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceListPrivDoctypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListPrivDoctypesGet$Response(params?: ApiV3ServiceListPrivDoctypesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PrivDoctypesApiFrom>>> {
    return apiV3ServiceListPrivDoctypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * list of documents to confirm benefits.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceListPrivDoctypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListPrivDoctypesGet(params?: ApiV3ServiceListPrivDoctypesGet$Params, context?: HttpContext): Observable<Array<PrivDoctypesApiFrom>> {
    return this.apiV3ServiceListPrivDoctypesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PrivDoctypesApiFrom>>): Array<PrivDoctypesApiFrom> => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceSetClientPrivPost()` */
  static readonly ApiV3ServiceSetClientPrivPostPath = '/api/v3/service/SetClientPriv';

  /**
   * setting benefits for the client's office.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceSetClientPrivPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceSetClientPrivPost$Response(params?: ApiV3ServiceSetClientPrivPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiV3ServiceSetClientPrivPost(this.http, this.rootUrl, params, context);
  }

  /**
   * setting benefits for the client's office.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceSetClientPrivPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceSetClientPrivPost(params?: ApiV3ServiceSetClientPrivPost$Params, context?: HttpContext): Observable<void> {
    return this.apiV3ServiceSetClientPrivPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceSetIdPrivPost()` */
  static readonly ApiV3ServiceSetIdPrivPostPath = '/api/v3/service/SetIdPriv';

  /**
   * setting benefits for the carrier (only for the "subordinate office").
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceSetIdPrivPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceSetIdPrivPost$Response(params?: ApiV3ServiceSetIdPrivPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiV3ServiceSetIdPrivPost(this.http, this.rootUrl, params, context);
  }

  /**
   * setting benefits for the carrier (only for the "subordinate office").
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceSetIdPrivPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceSetIdPrivPost(params?: ApiV3ServiceSetIdPrivPost$Params, context?: HttpContext): Observable<void> {
    return this.apiV3ServiceSetIdPrivPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
